import { AuthContextUserProps } from "../context/AuthContext/AuthContextProvider";

export const getLoggedInUserGid = (
  user?: Pick<AuthContextUserProps, "id"> | null
) => {
  if (!user?.id) {
    return undefined;
  }

  return String(user.id);
};

export const getLoggedInDatabaseId = (
  user?: Pick<AuthContextUserProps, "userId"> | null
) => {
  if (user?.userId == null) {
    return undefined;
  }

  const parsed =
    typeof user.userId === "string" ? parseInt(user.userId, 10) : user.userId;

  return Number.isFinite(parsed) ? parsed : undefined;
};
